/**
 * Template « Boudoir » — sombre, doré, premium. Porté 1:1 depuis le fichier
 * de référence (menu-templates.html, `.boudoir` + fonction `boudoir(m)`).
 * Styles en inline (pas de classes Tailwind) : ce noeud est la cible directe
 * de la rasterisation PNG (`domToPng`), les valeurs doivent rester stables
 * indépendamment du thème clair/sombre du cockpit — le template a sa PROPRE
 * palette fixe, volontairement déconnectée des tokens cockpit.
 */
import { forwardRef } from "react";

import type { MenuCardData } from "../types";
import { PortraitPlaceholder } from "./PortraitPlaceholder";

export const BoudoirTemplate = forwardRef<HTMLDivElement, { data: MenuCardData }>(
  function BoudoirTemplate({ data }, ref) {
    return (
      <div
        ref={ref}
        style={{
          boxSizing: "border-box",
          width: "100%",
          aspectRatio: "4 / 5",
          borderRadius: 16,
          overflow: "hidden",
          position: "relative",
          background: "#141109",
          color: "#f1e9d8",
          fontFamily: 'Georgia, "Times New Roman", serif',
          padding: "26px 26px 22px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            fontSize: 33,
            textAlign: "center",
            letterSpacing: "0.02em",
            margin: "0 0 2px",
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 14,
          }}
        >
          <span style={{ color: "#c6a96b", fontSize: 20 }}>✝</span>
          <span>{data.name}</span>
          <span style={{ color: "#c6a96b", fontSize: 20 }}>✝</span>
        </div>
        <div
          style={{
            height: 118,
            borderRadius: 10,
            overflow: "hidden",
            margin: "14px 0 16px",
            border: "1px solid rgba(198,169,107,.30)",
          }}
        >
          {data.photoUrl ? (
            <img
              src={data.photoUrl}
              alt=""
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
          ) : (
            <PortraitPlaceholder bg="#241d10" fg="rgba(198,169,107,.55)" />
          )}
        </div>
        <ul
          style={{
            listStyle: "none",
            margin: 0,
            padding: 0,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {data.lines.map((line, i) => (
            <li
              key={line.id}
              style={{
                display: "grid",
                gridTemplateColumns: "22px 1fr auto",
                alignItems: "center",
                gap: 11,
                padding: "6.5px 0",
                borderBottom:
                  i === data.lines.length - 1 ? "none" : "1px solid rgba(198,169,107,.14)",
                fontSize: 15,
              }}
            >
              <span
                style={{
                  fontFamily: '"Helvetica Neue", Arial, sans-serif',
                  fontSize: 14,
                  textAlign: "center",
                  opacity: 0.9,
                }}
              >
                {line.emoji}
              </span>
              <span style={{ color: "#efe6d3" }}>{line.label}</span>
              <span
                style={{
                  color: "#c6a96b",
                  fontVariantNumeric: "tabular-nums",
                  letterSpacing: "0.01em",
                }}
              >
                {line.price}
              </span>
            </li>
          ))}
        </ul>
        <div
          style={{
            fontFamily: '"Helvetica Neue", Arial, sans-serif',
            textAlign: "center",
            fontSize: 10.5,
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: "#8b7f63",
            marginTop: 14,
          }}
        >
          Envoie le montant pour débloquer
        </div>
      </div>
    );
  },
);
